export default __webpack_public_path__ + "static/media/Maple-LightItalic.7a071199.ttf";